import styled from 'styled-components/macro';
import Label from 'styled/Label';

const CustomLabel = styled(Label)`
  display: flex;
  margin-bottom: 16px;
  color: white;
  cursor: pointer;
`;

export default CustomLabel;
